import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
`;

const StyledBackground = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	background-image: linear-gradient(
			180deg,
			rgba(16, 19, 24, 1) 0%,
			rgba(16, 19, 24, 0) 200px
		),
		linear-gradient(180deg, rgba(16, 19, 24, 0) 0%, rgba(16, 19, 24, 1) 100%);
	background-size: contain, contain;
	background-repeat: no-repeat, no-repeat;
	background-position: top, top;
	opacity: 0.9;
`;

const StyledBackgroundImage = styled.div<{ $src: string }>`
	position: absolute;
	width: 100%;
	height: 520px;
	background-image: linear-gradient(
			180deg,
			rgba(16, 19, 24, 0) 0%,
			rgba(16, 19, 24, 1) 100%
		),
		url(${(props) => props.$src});
	background-repeat: no-repeat, no-repeat;
	background-size: contain, cover;
	background-position: top, center;
`;

export { StyledBackground, StyledBackgroundImage, StyledContainer };
